import { Splash, Radiostations, Error, Exit } from "../pages";
import { RadiostationsService } from "../services/radiostations.service";
import { ReportingService, TrackingAction } from "../services/reporting.service";
import { setDeviceInfo } from "./util";

export const pathNames = {
  Splash: "splash",
  Radiostations: "radiostations",
  Exit: "exit",
};

export default {
  root: pathNames.Radiostations,
  boot: () => {
    return new Promise((resolve, reject) => {
      setDeviceInfo()
        .then(() => {
          // Getting configuration/localization file with all the config and API endpoints needed to start the app
          RadiostationsService.initialize()
            .then(() => {
              resolve();
            })
            .catch(error => {
              ReportingService.trackAndReport({
                action: TrackingAction.FetchRadiostationsFailure,
                sendImmediate: true,
              });
              reject();
            });
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  bootComponent: Splash,
  routes: [
    {
      path: pathNames.Splash,
      component: Splash,
      widgets: ["Loader", "Logger"],
    },
    {
      path: pathNames.Radiostations,
      component: Radiostations,
      widgets: ["Loader", "Logger"],
    },
    {
      path: pathNames.Exit,
      component: Exit,
      widgets: ["Loader", "Logger"],
    },
    {
      path: "*",
      component: Splash,
    },
    {
      path: "!",
      component: Error,
    },
  ],
};
